import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import Money from '../../../common/money';
import PaymentTable from '../../../common/PaymentTable';

const PaymentRow = ({ item }) => (
  <PaymentTable.Row>
    <PaymentTable.Cell>
      Payment ({item.label})
    </PaymentTable.Cell>
    <PaymentTable.Cell data-automation-id="text:paymentAmount">
      <Money>{item.amount}</Money>
    </PaymentTable.Cell>
  </PaymentTable.Row>
);
PaymentRow.propTypes = {
  item: PropTypes.shape({
    label: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
  }).isRequired,
};

const TipRow = ({ item }) => (
  <PaymentTable.Row>
    <PaymentTable.Cell>
      - {item.firstName}&apos;s Tips
    </PaymentTable.Cell>
    <PaymentTable.Cell data-automation-id="text:tipsAmount">
      <Money>{item.amount}</Money>
    </PaymentTable.Cell>
  </PaymentTable.Row>
);
TipRow.propTypes = {
  item: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
  }).isRequired,
};

const PaymentSummary = ({ paymentMethods, tips, total, adjustments }) => (
  <PaymentTable className="u-bg-white">

    <PaymentTable.Row display-if={adjustments}>
      <PaymentTable.Cell>Total</PaymentTable.Cell>
      <PaymentTable.Cell data-automation-id="text:totalWithoutAdjustmentsAmount">
        <Money>{total - adjustments}</Money>
      </PaymentTable.Cell>
    </PaymentTable.Row>

    <PaymentTable.Row display-if={adjustments}>
      <PaymentTable.Cell>Promos/Discounts</PaymentTable.Cell>
      <PaymentTable.Cell className="u-co-red" data-automation-id="text:promosAmount">
        <Money>{adjustments}</Money>
      </PaymentTable.Cell>
    </PaymentTable.Row>

    <PaymentTable.Row className="u-type--bold">
      <PaymentTable.Cell>
        Total to Charge
      </PaymentTable.Cell>
      <PaymentTable.Cell data-automation-id="text:totalToChargeAmount">
        <Money>{total}</Money>
      </PaymentTable.Cell>
    </PaymentTable.Row>

    {!isEmpty(paymentMethods) && paymentMethods.map((item) => {
      const rows = [(
        <PaymentRow key={item.id} item={item} />
      )];
      tips.forEach((tip) => {
        if (tip.paymentId === item.id) {
          rows.push(<TipRow key={tip.barberId} item={tip} />);
        }
      });
      return rows;
    })}
    {isEmpty(paymentMethods) && tips.map(tip => <TipRow key={tip.barberId} item={tip} />)}
  </PaymentTable>
);
PaymentSummary.propTypes = {
  paymentMethods: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
  })),
  tips: PropTypes.arrayOf(PropTypes.shape({
    barberId: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    amount: PropTypes.number,
  })),
  total: PropTypes.number,
  adjustments: PropTypes.number,
};
PaymentSummary.defaultProps = {
  paymentMethods: [],
  tips: [],
  total: 0,
  adjustments: 0,
};

export default PaymentSummary;
